import { system } from 'styled-system';
/**
 * @public
 */
export const objectFitValues = ['contain', 'cover', 'unset'];
/**
 * @public
 */
export function objectFit() {
  return system({
    objectFit: {
      property: 'objectFit',
      transform: val => val ?? 'unset'
    }
  });
}